import React from 'react';
import { Field } from 'redux-form';
import { Col, FormGroup, Label } from 'reactstrap';
import Brick from './BrickCore';

/**
 * Workflow brick: apply a Kronos access profile (abilities_templates) to a user.
 * Stores only the template index; abilities are resolved live on the instance at runtime.
 *
 * [server_side]
 */
class UserApplyAbilitiesBrick extends Brick {
    /**
     * @param {{ abilities_templates?: object[] }|null|undefined} detailCtx
     * @returns {string|null}
     */
    getNodeDetails(detailCtx) {
        const templates = detailCtx?.abilities_templates || [];
        const templateId = this.getOption('template_id');
        if (templateId == null || templateId === '') {
            return null;
        }
        const index = Number(templateId);
        const template = Number.isFinite(index) ? templates[index] : null;
        const name = template?.name != null ? String(template.name).trim() : '';
        if (name) {
            return this.truncateNodeDetail(name, 40);
        }
        return this.truncateNodeDetail(`#${templateId}`, 40);
    }

    /**
     * @param {Object} props
     * @param {Function} props.t
     * @param {Array<{ name?: string, abilities?: object }>|undefined} props.abilities_templates
     */
    getOptionsForm(props) {
        const { t, abilities_templates } = props;
        const templates = Array.isArray(abilities_templates) ? abilities_templates : [];

        return (
            <>
                <FormGroup row>
                    <Label for="template_id" className="text-v-center" sm={12}>
                        {t('workflows.bricks.user.apply.abilities.options.template_id')}
                    </Label>
                    <Col sm={12}>
                        <Field
                            component="select"
                            name={`bricks[${this.position}].options.template_id`}
                            className="form-control"
                            disabled={templates.length === 0}
                        >
                            <option value="">
                                {t('workflows.bricks.user.apply.abilities.options.template_id_placeholder')}
                            </option>
                            {templates.map((template, index) => (
                                <option key={index} value={index}>
                                    {template?.name || `#${index}`}
                                </option>
                            ))}
                        </Field>
                        {templates.length === 0 && (
                            <small className="form-text text-warning">
                                {t('workflows.bricks.user.apply.abilities.options.no_templates')}
                            </small>
                        )}
                        <small className="form-text text-muted">
                            {t('workflows.bricks.user.apply.abilities.options.template_id_help')}
                        </small>
                    </Col>
                </FormGroup>
            </>
        );
    }
}

export default UserApplyAbilitiesBrick;
